import type { FC, ReactNode } from 'react';
import Maintenance from 'src/pages/error/Maintenance';
import { isOnMaintenance } from 'src/utils/maintenance';

export type MaintenanceGuardProps = {
  children: ReactNode;
};

export const MaintenanceGuard: FC<MaintenanceGuardProps> = ({ children }) => {
  if (isOnMaintenance()) {
    return <Maintenance />;
  }

  return <>{children}</>;
};

export default MaintenanceGuard;
